import {
  IProduct,
  IProductMenuDisplay,
} from 'core/redux/features/products/types';
import { Column, Columns } from 'Components/Elements';
import React, { Component } from 'react';
import { AppState } from 'core/redux/reducers';
import { connect } from 'react-redux';
import TextEllipsis from 'Components/TextEllipsis';
import { voidCallback } from 'core/utils';
import { ChildComponentProps, Coords } from 'google-map-react';
import { getProductMenuListPreview } from 'core/redux/features/products/reducers/products';
import classNames from 'classnames';
import { CardFooter } from './CardFooter';

interface IProps extends ChildComponentProps {
  product: IProduct;
  menuPreviews: IProductMenuDisplay[];
  onClick: (e: React.SyntheticEvent, p: IProduct) => void;
  $onMouseAllow?: (arg: boolean) => void;
  className?: string;
  deviceType: string;
}

export function PlainMapBoard(
  props: {
    className?: string;
    onMouseEnter?: (_: React.SyntheticEvent) => void;
    onMouseLeave?: (_: React.SyntheticEvent) => void;
    onClick?: (e: React.SyntheticEvent) => void;
    product?: IProduct;
    productDesc?: string;
    deviceType?: string;
    menus?: IProductMenuDisplay[];

    title?: string;
    description?: string;
  } & Coords,
) {
  return (
    <div
      className={classNames('map-board', props.className)}
      onMouseEnter={props?.onMouseEnter}
      onMouseLeave={props?.onMouseLeave}
      onClick={props.onClick}
    >
      {props.title ? (
        <div className="title">
          {props.title}
          <span className="icon eb eb-rl" />
        </div>
      ) : null}
      <div className="map-board__content">
        {props.description ? (
          <Columns gap={1} mobile={true}>
            <Column size={7}>
              <TextEllipsis observe={false} clump={2} className="desc">
                {props.description}
              </TextEllipsis>
            </Column>
            <Column size={5}>
              <div className="price">
                <div className="sale">{props.product.price_sale} KR</div>
                <div className="normal">{props.product.price_regular} KR</div>
              </div>
            </Column>
          </Columns>
        ) : null}
        {props.deviceType && props.product && props.menus ? (
          <CardFooter
            deviceType={props.deviceType}
            hideDescription={true}
            product={props.product}
            menus={props.menus}
          />
        ) : null}
      </div>
    </div>
  );
}

export class MapBord extends Component<IProps> {
  static defaultProps = {
    onClick: voidCallback,
  };

  render() {
    const { product, menuPreviews, className, deviceType, onClick, ...others } =
      this.props;
    const productDesc =
      deviceType === 'mobile'
        ? product?.mobile_description
        : product?.short_description;
    return (
      <PlainMapBoard
        title={product.name}
        className={className}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.onClickBoard}
        product={product}
        description={productDesc}
        deviceType={deviceType}
        menus={menuPreviews}
        {...others}
      />
    );
  }

  private onMouseEnter = (_: React.SyntheticEvent) => {
    if (this.props.$onMouseAllow) {
      this.props.$onMouseAllow(false);
    }
  };

  private onMouseLeave = (_: React.SyntheticEvent) => {
    if (this.props.$onMouseAllow) {
      this.props.$onMouseAllow(true);
    }
  };

  private onClickBoard = (e: React.SyntheticEvent) => {
    this.props.onClick(e, this.props.product);
  };
}

export const configure = connect(
  (state: AppState) => ({
    menuPreviews: getProductMenuListPreview(state),
    deviceType: state.deviceType,
  }),
  {},
)(MapBord);

export default configure;
